import React, { useState } from "react";
import {
  Box,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import { supabase } from "../../lib/supabaseClient";
import { useNavigate } from "react-router-dom";

const PasswordTab = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (formData.currentPassword === formData.newPassword) {
      toast({
        title: "현재 비밀번호와 새 비밀번호가 같습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      toast({
        title: "새 비밀번호가 일치하지 않습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (formData.newPassword.length < 6) {
      toast({
        title: "비밀번호는 6자 이상이어야 합니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // 소문자, 숫자, 특수기호 각각 1개 이상 포함 검사
    const lower = /[a-z]/;
    const number = /[0-9]/;
    const special = /[!@#$%^&*(),.?":{}|<>\[\]\\/~`';_+=-]/;
    if (
      !lower.test(formData.newPassword) ||
      !number.test(formData.newPassword) ||
      !special.test(formData.newPassword)
    ) {
      toast({
        title:
          "비밀번호는 소문자, 숫자, 특수기호를 각각 1개 이상 포함해야 합니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);
    try {
      // 현재 로그인된 사용자 정보 가져오기
      const {
        data: { user },
      } = await supabase.auth.getUser();
      // 현재 비밀번호가 맞는지 검증
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: user.email,
        password: formData.currentPassword,
      });
      if (signInError) {
        toast({
          title: "현재 비밀번호가 올바르지 않습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
        return;
      }

      const { error } = await supabase.auth.updateUser({
        password: formData.newPassword,
      });

      if (error) throw error;

      toast({
        title: "비밀번호가 성공적으로 변경되었습니다.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // 폼 초기화
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      // 홈으로 이동
      navigate("/");
    } catch (error) {
      console.error("Error updating password:", error);
      toast({
        title: "비밀번호 변경 실패",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <FormControl>
          <FormLabel>현재 비밀번호</FormLabel>
          <Input
            type="password"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleInputChange}
            placeholder="현재 비밀번호를 입력하세요"
          />
        </FormControl>

        <FormControl>
          <FormLabel>새 비밀번호</FormLabel>
          <Input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleInputChange}
            placeholder="새 비밀번호를 입력하세요"
          />
        </FormControl>

        <FormControl>
          <FormLabel>새 비밀번호 확인</FormLabel>
          <Input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            placeholder="새 비밀번호를 다시 입력하세요"
          />
        </FormControl>

        <Button
          colorScheme="blue"
          size="lg"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          비밀번호 변경
        </Button>
      </VStack>
    </Box>
  );
};

export default PasswordTab;
